module.exports = __webpack_public_path__ + "static/media/picto-camera.17f67269.svg";